
import Slider from "./slider";

import BackToTop from "../backToTop";
import { PropTypes } from 'prop-types';

import SideMenu from "../sideMenu/sideMenu";

const Accommodation = ({ imgSlider,contents, list, children }) => {

    return (

        <section className="p-4 sm:p-8">
            <div className="flex flex-col gap-8">

                <Slider imgs={imgSlider} />

                <div className="pt-8">
                        <SideMenu contents={contents} list={list}>
                            {children}
                        </SideMenu>
                </div>
                <div className="w-full p-8">
                    <BackToTop />
                </div>
            </div>
        </section>
    )
}
Accommodation.propTypes = {
    imgSlider: PropTypes.array,
    list: PropTypes.array,
    contents: PropTypes.array,
    children: PropTypes.node
}
export default Accommodation